import { render, staticRenderFns } from "./RecordDialog copy.vue?vue&type=template&id=24554602&scoped=true&"
import script from "./RecordDialog copy.vue?vue&type=script&lang=js&"
export * from "./RecordDialog copy.vue?vue&type=script&lang=js&"
import style0 from "./RecordDialog copy.vue?vue&type=style&index=0&id=24554602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24554602",
  null
  
)

export default component.exports